module.exports = __webpack_public_path__ + "img/link-03.db4de3bd.svg";